(function () {
  var SCORE_MAP = {
    1: "1 - Least Likely",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: 7,
    8: 8,
    9: "9",
    10: "10 - Most Likely"
  };

  function getQueryParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || "";
    } catch (error) {
      return "";
    }
  }

  function isDebugMode() {
    return getQueryParam("nps_debug") === "1";
  }

  function isValidEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  }

  function getKlaviyoCompanyId(form) {
    if (form.dataset.klaviyoCompanyId) {
      return form.dataset.klaviyoCompanyId.trim();
    }

    var scripts = document.querySelectorAll('script[src*="klaviyo.com"]');
    for (var i = 0; i < scripts.length; i++) {
      var match = scripts[i].src.match(/company_id=([^&]+)/);
      if (match) {
        return decodeURIComponent(match[1]);
      }
    }

    return "";
  }

  function mapScoreValue(score) {
    return SCORE_MAP[score] !== undefined ? SCORE_MAP[score] : String(score);
  }

  function buildProfileProperties(config, score, bestPartValue, wouldChangeValue) {
    var properties = {};
    properties[config.scoreProperty] = mapScoreValue(score);

    if (bestPartValue && config.bestPartProperty) {
      properties[config.bestPartProperty] = bestPartValue;
    }

    if (wouldChangeValue && config.wouldChangeProperty) {
      properties[config.wouldChangeProperty] = wouldChangeValue;
    }

    if (config.npsAnsweredProperty && config.npsAnsweredValue) {
      properties[config.npsAnsweredProperty] = config.npsAnsweredValue;
    }

    return properties;
  }

  function pushIdentifyFallback(email, properties) {
    if (!window._learnq) return;

    var identifyProps = { $email: email };
    Object.keys(properties).forEach(function (key) {
      identifyProps[key] = properties[key];
    });
    window._learnq.push(["identify", identifyProps]);
  }

  function buildProfilePayload(email, properties) {
    return {
      data: {
        type: "profile",
        attributes: {
          email: email,
          properties: properties
        }
      }
    };
  }

  function getPageUrl() {
    return window.location.host + window.location.pathname.replace(/\/$/, "");
  }

  function getVariantLabel(config) {
    var isMobile = window.matchMedia("(max-width: 767.98px)").matches;
    return isMobile ? config.variantMobile : config.variantDesktop;
  }

  /**
   * Instapage-compatible webhook body the Praella automation endpoints expect.
   */
  function buildWebhookPayload(config, email, score, experience, suggestions) {
    return {
      ip: "",
      nps: String(mapScoreValue(score)),
      email: email,
      page_id: config.pageId,
      variant: getVariantLabel(config),
      page_url: getPageUrl(),
      page_name: config.pageName,
      experience: experience,
      suggestions: suggestions
    };
  }

  /**
   * Notifies the automation endpoints. Fire and forget: a failure here must never
   * block the thank you state, so errors surface only under ?nps_debug=1.
   */
  function notifyWebhooks(urls, payload) {
    var body = JSON.stringify(payload);

    urls.forEach(function (url) {
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        keepalive: true,
        body: body
      })
        .then(function (response) {
          if (isDebugMode()) {
            console.info("[BattlBox NPS] Webhook", url, "responded", response.status);
          }
        })
        .catch(function (error) {
          if (isDebugMode()) {
            console.warn("[BattlBox NPS] Webhook failed:", url, error);
          }
        });
    });
  }

  function updateKlaviyoProfile(companyId, email, properties) {
    return fetch(
      "https://a.klaviyo.com/client/profiles/?company_id=" + encodeURIComponent(companyId),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          revision: "2024-07-15"
        },
        body: JSON.stringify(buildProfilePayload(email, properties))
      }
    );
  }

  function subscribeToKlaviyoList(subscribeKey, listId, email) {
    var body = new URLSearchParams();
    body.append("g", listId);
    body.append("email", email);

    return fetch(
      "https://manage.kmail-lists.com/ajax/subscriptions/subscribe?a=" + encodeURIComponent(subscribeKey),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: body
      }
    ).then(function (response) {
      return response.json().then(function (payload) {
        return {
          ok: response.ok && payload && payload.success === true,
          status: response.status,
          payload: payload
        };
      });
    });
  }

  function showThankYou(formState, thankYouState, submitBtn) {
    if (formState) {
      formState.style.display = "none";
    }
    if (thankYouState) {
      thankYouState.classList.add("is-visible");
    }
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = submitBtn.getAttribute("data-default-text") || "Submit Feedback";
    }
  }

  function selectScore(blazes, val, el, scoreInput) {
    scoreInput.value = String(val);
    blazes.forEach(function (b) {
      var isSelected = b === el;
      b.classList.toggle("is-selected", isSelected);
      b.setAttribute("aria-checked", isSelected ? "true" : "false");
      b.setAttribute("tabindex", isSelected ? "0" : "-1");
    });
  }

  function initNpsSurvey(form) {
    if (!form || form.dataset.npsReady === "true") return;
    form.dataset.npsReady = "true";

    var ratingWrap = form.querySelector("[data-nps-rating]");
    var scoreInput = form.querySelector("[data-nps-score]");
    var emailInput = form.querySelector("[data-nps-email]");
    var submitBtn = form.querySelector("[data-nps-submit]");
    var errorEl = form.querySelector("[data-nps-error]");
    var formState = document.querySelector(form.dataset.formState);
    var thankYouState = document.querySelector(form.dataset.thankyouState);

    if (!ratingWrap || !scoreInput) return;

    var blazes = Array.from(ratingWrap.querySelectorAll("[data-nps-score-btn]"));
    var config = {
      scoreProperty: form.dataset.scoreProperty || "Champion - NPS Score",
      bestPartProperty: form.dataset.bestPartProperty || "",
      wouldChangeProperty: form.dataset.wouldChangeProperty || "",
      npsAnsweredProperty: form.dataset.npsAnsweredProperty || "",
      npsAnsweredValue: form.dataset.npsAnsweredValue || "",
      klaviyoListId: form.dataset.klaviyoListId || "",
      klaviyoSubscribeKey: form.dataset.klaviyoSubscribeKey || "RELrxS",
      subscribeToList: form.dataset.subscribeToList !== "false",
      webhookUrls: [form.dataset.npsWebhookUrl, form.dataset.trustpilotWebhookUrl]
        .map(function (url) {
          return (url || "").trim();
        })
        .filter(function (url) {
          return url.indexOf("http") === 0;
        }),
      pageId: form.dataset.webhookPageId || "",
      pageName: form.dataset.webhookPageName || "BattlBox NPS",
      variantDesktop: form.dataset.webhookVariantDesktop || "Variation B-desktop",
      variantMobile: form.dataset.webhookVariantMobile || "Variation B-mobile",
      prefilledEmail: form.dataset.prefilledEmail || getQueryParam("email"),
      defaultError: errorEl ? errorEl.textContent : "Please pick a score and enter a valid email before submitting."
    };

    if (isDebugMode()) {
      console.info("[BattlBox NPS] Debug mode on.");
      console.info("[BattlBox NPS] Klaviyo company ID:", getKlaviyoCompanyId(form) || "(not found)");
      console.info("[BattlBox NPS] Property mapping:", config);
    }

    if (emailInput && config.prefilledEmail) {
      emailInput.value = config.prefilledEmail;
    }

    blazes.forEach(function (blaze, idx) {
      blaze.addEventListener("click", function () {
        selectScore(blazes, blaze.getAttribute("data-val"), blaze, scoreInput);
      });

      blaze.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          selectScore(blazes, blaze.getAttribute("data-val"), blaze, scoreInput);
        }
        if (event.key === "ArrowRight" && blazes[idx + 1]) {
          blazes[idx + 1].focus();
        }
        if (event.key === "ArrowLeft" && blazes[idx - 1]) {
          blazes[idx - 1].focus();
        }
      });
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      if (errorEl) {
        errorEl.classList.remove("is-visible");
        errorEl.textContent = config.defaultError;
      }

      var score = parseInt(scoreInput.value, 10);
      var email = emailInput ? emailInput.value.trim() : config.prefilledEmail;
      var companyId = getKlaviyoCompanyId(form);

      if (!score || score < 1 || score > 10 || !isValidEmail(email)) {
        if (errorEl) {
          errorEl.textContent = config.defaultError;
          errorEl.classList.add("is-visible");
        }
        return;
      }

      if (!companyId) {
        if (errorEl) {
          errorEl.textContent = "Klaviyo is not configured on this page. Please contact support.";
          errorEl.classList.add("is-visible");
        }
        return;
      }

      var bestPart = form.querySelector("[data-nps-best-part]");
      var wouldChange = form.querySelector("[data-nps-would-change]");
      var bestPartValue = bestPart ? bestPart.value.trim() : "";
      var wouldChangeValue = wouldChange ? wouldChange.value.trim() : "";
      var profileProperties = buildProfileProperties(config, score, bestPartValue, wouldChangeValue);

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.getAttribute("data-loading-text") || "Submitting…";
      }

      if (isDebugMode()) {
        console.group("[BattlBox NPS] Klaviyo client profile payload");
        console.log(
          JSON.stringify(
            {
              company_id: companyId,
              email: email,
              properties: profileProperties
            },
            null,
            2
          )
        );
        console.groupEnd();
      }

      updateKlaviyoProfile(companyId, email, profileProperties)
        .then(function (response) {
          if (isDebugMode()) {
            console.info("[BattlBox NPS] Klaviyo response status:", response.status);
          }

          if (response.status === 202 || response.ok) {
            pushIdentifyFallback(email, profileProperties);

            if (isDebugMode()) {
              console.info("[BattlBox NPS] Profile update accepted by Klaviyo.");
              console.info("[BattlBox NPS] Notifying webhooks:", config.webhookUrls);
            }

            if (config.webhookUrls.length) {
              var webhookPayload = buildWebhookPayload(
                config,
                email,
                score,
                bestPartValue,
                wouldChangeValue
              );

              if (isDebugMode()) {
                console.info("[BattlBox NPS] Webhook payload:", webhookPayload);
              }

              notifyWebhooks(config.webhookUrls, webhookPayload);
            }

            if (config.subscribeToList && config.klaviyoListId && config.klaviyoSubscribeKey) {
              return subscribeToKlaviyoList(config.klaviyoSubscribeKey, config.klaviyoListId, email).then(function (listResult) {
                if (isDebugMode()) {
                  console.info("[BattlBox NPS] MASTER list subscription:", listResult);
                }

                if (!listResult.ok && isDebugMode()) {
                  console.warn("[BattlBox NPS] List subscription failed:", listResult.payload);
                }
              });
            }

            if (isDebugMode() && config.subscribeToList && !config.klaviyoListId) {
              console.warn("[BattlBox NPS] List subscription skipped — add MASTER list ID in theme settings.");
            }

            return;
          }

          return response.text().then(function (body) {
            if (isDebugMode()) {
              console.error("[BattlBox NPS] Klaviyo error response:", body);
            }
            throw new Error("Klaviyo profile update failed");
          });
        })
        .then(function () {
          showThankYou(formState, thankYouState, submitBtn);
        })
        .catch(function (error) {
          if (isDebugMode()) {
            console.error("[BattlBox NPS] Submit failed:", error);
          }

          if (errorEl) {
            errorEl.textContent = "We couldn't save your feedback. Please try again.";
            errorEl.classList.add("is-visible");
          }

          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.getAttribute("data-default-text") || "Submit Feedback";
          }
        });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll("[data-partner-nps-survey]").forEach(initNpsSurvey);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
